import { MAX_SPLIT_LINE_NUMBER } from '../../util/const';

/**
 * @param value 可以是dom的宽或是高
 * @returns {number} 分割线的数量
 */
export function getSplitLineNumber(value: number) {
  /** 最少需要两根分割线 */
  const splitLineNumber = Math.max(Math.floor(value / 32), 2);
  /** 最多不超过7根 */
  return Math.min(splitLineNumber, MAX_SPLIT_LINE_NUMBER);
}

export default getSplitLineNumber;
